/* eslint-disable i18next/no-literal-string */
import { useCurrentUser } from '@hotjar/user';
import { Button, Modal } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

export interface EntityDeleteModalProps {
  isOpen: boolean;
  onContinue: () => void;
  onClose: () => void;
}

export function FileTooLargeModal({
  isOpen,
  onContinue,
  onClose,
}: EntityDeleteModalProps): JSX.Element {
  const email = useCurrentUser().data?.email;
  const { t } = useTranslation('feedback', { keyPrefix: 'survey-responses.export' });
  return (
    <Modal contentLabel={t('content-label')} isOpen={isOpen} onClose={onClose}>
      <Modal.Header title={t('title')} />
      <Modal.Body>
        {t('response-threshold-message', { email: email ?? t('your-email') })}
      </Modal.Body>
      <Modal.Footer>
        <Button kind="ghost" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button kind="primary" onClick={onContinue}>
          {t('continue')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
